import { render, staticRenderFns } from "./channelStock.vue?vue&type=template&id=613a27c5&scoped=true&"
import script from "./channelStock.vue?vue&type=script&lang=js&"
export * from "./channelStock.vue?vue&type=script&lang=js&"
import style0 from "./channelStock.vue?vue&type=style&index=0&id=613a27c5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613a27c5",
  null
  
)

export default component.exports